import * as uuid from "uuid";

export type TriggerType = "transaction" | "static_time_inactivity" | "dynamic_inactivity";

export class AutomationTrigger {
  local_uuid: string;
  type: TriggerType;
  delay: number;
  inactive_days: number;
  atg_multiplier: number;

  static readonly MIN_ATG_MULTIPLIER = 2.5;
  static readonly MAX_ATG_MULTIPLIER = 10.0;

  constructor(data: Partial<AutomationTrigger>) {
    this.type = data.type;
    this.delay = data.delay;
    this.inactive_days = data.inactive_days;
    this.atg_multiplier = data.atg_multiplier;

    this.local_uuid = uuid.v4();
  }

  public valid(): boolean {
    switch (this.type) {
      case "transaction":
        return this.delay != null && this.delay >= 0;
      case "static_time_inactivity":
        return this.inactive_days != null && this.inactive_days > 0;
      case "dynamic_inactivity":
        return this.atg_multiplier != null && this.atg_multiplier > 0;
      default:
        console.error("Unknown trigger type", this.type);
        return false;
    }
  }

  public asRequest(): Partial<AutomationTrigger> | any {
    const request = {
      type: this.type
    };
    switch (this.type) {
      case "transaction":
        request["delay"] = this.delay;
        break;
      case "static_time_inactivity":
        request["inactive_days"] = this.inactive_days;
        break;
      case "dynamic_inactivity":
        request["atg_multiplier"] = this.atg_multiplier;
        break;
    }
    return request;
  }
}
